<template>
  <div>
    <transition :name="transitionName" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  computed: {
    transitionName () {
      return this.$store.getters.transitionName
    }
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?7ac622a6